import { render, staticRenderFns } from "./StatusTemplate.vue?vue&type=template&id=d38c4292"
import script from "./StatusTemplate.vue?vue&type=script&lang=js"
export * from "./StatusTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports